const Fez = window.Fez;
if (!Fez) throw new Error('fez runtime not loaded: load fez (window.Fez) before component modules');

// --- ui-toast ---
let __fez_component_0;
{
const TONES = {
  success: { icon: 'check-circle', ms: 4000 },
  info: { icon: 'info', ms: 4000 },
  error: { icon: 'warning-circle', ms: 8000 },
}
__fez_component_0 = class {
  MOUNT = true
  GLOBAL = 'Toast'

  init() {
    this.state.items = []
    this.state.seq = 0
    this.state.hovered = false
  }

  show(text, tone = 'info', { action, ms } = {}) {
    const id = ++this.state.seq
    const spec = TONES[tone] || TONES.info
    this.state.items = [...this.state.items.slice(-3), { id, tone, text, icon: spec.icon, action: action ? action.label : '' }]
    if (action) this.state.actions = { ...this.state.actions, [id]: action.run }
    this.setTimeout(() => this.expire(id), ms || spec.ms)
    return id
  }

  success(text, options) {
    return this.show(text, 'success', options)
  }

  info(text, options) {
    return this.show(text, 'info', options)
  }

  error(text, options) {
    return this.show(text, 'error', options)
  }

  act(id) {
    const run = this.state.actions?.[id]
    this.dismiss(id)
    run?.()
  }

  expire(id) {
    if (this.state.hovered) {
      this.setTimeout(() => this.expire(id), 1500)
      return
    }
    this.dismiss(id)
  }

  dismiss(id) {
    this.state.items = this.state.items.filter((item) => item.id !== id)
    if (this.state.actions?.[id]) delete this.state.actions[id]
  }

  hover(on) {
    this.state.hovered = on
  }

  CSS = `:fez {
display:contents;.stack{position:fixed;left:50%;bottom:var(--space-6);z-index:var(--z-toast);display:flex;flex-direction:column;align-items:center;gap:var(--space-2);width:max-content;max-width:calc(100vw - var(--space-8));transform:translateX(-50%);pointer-events:none}.toast{display:flex;align-items:center;gap:var(--space-3);min-height:44px;max-width:520px;padding:var(--space-2) var(--space-2) var(--space-2) var(--space-4);border:1px solid var(--color-border);border-radius:var(--radius-lg);background:var(--color-bg-raised);color:var(--color-text);box-shadow:var(--shadow-lg);font-size:var(--text-sm);font-weight:var(--weight-medium);pointer-events:auto}.success .tone{color:var(--color-success)}.info .tone{color:var(--color-accent)}.error .tone{color:var(--color-danger)}.text{flex:1}.action{padding:var(--space-1) var(--space-2);border:0;border-radius:var(--radius-sm);background:transparent;color:var(--color-link);font:inherit;font-weight:var(--weight-semibold);cursor:pointer;&:hover{background:var(--color-bg-hover)}}.close{display:inline-flex;padding:6px;border:0;border-radius:var(--radius-sm);background:transparent;color:var(--color-text-subtle);cursor:pointer;&:hover{background:var(--color-bg-hover);color:var(--color-text)}}
}`

  HTML = `<div class="stack" role="status" aria-live="polite" onmouseenter="fez.hover(true)" onmouseleave="fez.hover(false)">
{#each state.items as item}
<div class="toast {item.tone}" key="toast-{item.id}" fez:in="fly, y=16, duration=220" fez:out="fade, duration=160">
<span class="tone"><ui-icon name={item.icon} size="18" weight="fill"></ui-icon></span>
<span class="text">{item.text}</span>
{#if item.action}
<button class="action" type="button" onclick="fez.act({item.id})">{item.action}</button>
{/if}
<button class="close" type="button" aria-label="Dismiss" onclick="fez.dismiss({item.id})"><ui-icon name="x" size="14"></ui-icon></button>
</div>
{/each}
</div>`
};
}

Fez('ui-toast', __fez_component_0);

export default __fez_component_0;
